document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('active');
    });
  }

  /* ---------- Search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('active');
      if (searchPanel.classList.contains('active')) {
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartDrawerOverlay');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;

  function openCart() {
    if (!cartDrawer) return;
    renderCartDrawer();
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('active');
    cartOverlay.classList.remove('active');
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('CartDrawerItems');
        var subtotalEl = document.getElementById('CartDrawerSubtotal');
        var countEls = document.querySelectorAll('[data-cart-count]');

        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (itemsEl) {
          if (cart.items.length === 0) {
            itemsEl.innerHTML = '<p>Your bag is empty.</p>';
          } else {
            itemsEl.innerHTML = cart.items.map(function (item) {
              return (
                '<div class="cart-drawer__item" style="display:flex;gap:14px;margin-bottom:18px;">' +
                  (item.image ? '<img src="' + item.image + '" alt="" style="width:64px;height:85px;object-fit:cover;">' : '') +
                  '<div><p style="margin:0 0 4px;font-size:0.9rem;">' + item.product_title + '</p>' +
                  '<p style="margin:0;font-size:0.8rem;color:#767676;">' + item.variant_title + ' &times; ' + item.quantity + '</p>' +
                  '<p style="margin:4px 0 0;font-size:0.85rem;">' + formatMoney(item.final_line_price) + '</p></div>' +
                '</div>'
              );
            }).join('');
          }
        }
      })
      .catch(function (err) { console.error('Cart fetch failed', err); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) submitBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (submitBtn) submitBtn.textContent = originalText;
          openCart();
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (submitBtn) submitBtn.textContent = originalText;
        });
    });
  }

  /* ---------- Product option swatches (simple: sets hidden variant id if exact match found) ---------- */
  document.querySelectorAll('.product__swatches').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.swatch');
      if (!btn) return;
      group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ---------- Product media thumbnails ---------- */
  document.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = thumb.getAttribute('data-media-thumb');
      document.querySelectorAll('.product__media-item').forEach(function (item) {
        item.classList.toggle('active', item.getAttribute('data-media-id') === id);
      });
      document.querySelectorAll('.product__media-thumb').forEach(function (t) {
        t.classList.toggle('active', t === thumb);
      });
    });
  });

});
